var SitePage = require('../views/masters/SitePage');
var $ = require('jquery');
var Validate = require('../lib/validate');
var UIView = require('../modules/ui/uiview');

/**
 * HomePage
 * @constructor
 * @description represent Home Page
 * @extends SitePage
 * @param {Object} options - object contain any attributes
 */

function Contacto(options){
    SitePage.call(this);
    this.options = options;
    this.modalView = new UIView({ el: $('#answerContacto') });
}

Contacto.prototype = $.extend(Object.create(SitePage.prototype), {

  constructor: Contacto,

  /**
   * Executes when document DOM Tree is ready.
   */
  ready: function() {
    console.log("Ready: 	");
    SitePage.prototype.ready.call(this);

    var $formContact = $("form.contacto");
    Validate.form($formContact);
    $formContact.on('submit', this.validateForm.bind(this));
  },

  /**
   * Executes when the window is fully loaded.
   */
  load: function(){
    console.log("Load: Contacto");

    var textarea = document.getElementById('g-recaptcha-response');
    Object.defineProperty(textarea, "value", {
        get:function(){
          return this.getAttribute("value");
        },
        set:function(val){
          console.log("set");

          // handle value change here
          this.setAttribute("value",val);

          //fire the event
          if ("createEvent" in document) {  //NON IE browsers
            var evt = document.createEvent("HTMLEvents");
            evt.initEvent("change", false, true);
            textarea.dispatchEvent(evt);
          }
          else {  //IE
            var evt = document.createEventObject();
            textarea.fireEvent("onchange", evt);
          }
          console.log(this.getAttribute("value"));
        }
      });

    $('#g-recaptcha-response').on('change', function (){
      $('.recaptcha-contacto').find('label').remove();
    });
  },

  validateForm: function (evt){
    var googleResponse = $('#g-recaptcha-response').val();
    if (googleResponse) {
      $('#captcha').val(googleResponse);
    }

    // if (!Validate.isValid($(evt.target)) || $('#captcha').val() == '') {
   //      if ($('#captcha').val() == '' && !$('.recaptcha-contacto').find('label').length) {
   //        $('.recaptcha-contacto').append('<label style="color:red">Campo obligatorio, se requiere que completes esta opción</label>')
   //      }
   //      return false;
   //  }
   //  $('#g-recaptcha-response').val($('#captcha').val());
   //  console.log($('textarea[name="g-recaptcha-response"]').val());
   //  $(evt.target).unbind().submit();
    if (!Validate.isValid($(evt.target)) || $('#captcha').val() == '') {
  	    evt.preventDefault();
        if ($('#captcha').val() == '' && !$('.recaptcha-contacto').find('label').length) {
            $('.recaptcha-contacto').append('<label style="color:red">Campo obligatorio, se requiere que completes esta opción</label>')
        }
        return false;
    }
  }

});

// Create a instace of this page;
new Contacto({ data: {} });
